import React from 'react'
import feature from '../../Image/Service/Feature.svg'
import fullStackfeature from '../../Image/FullStack/Feature.svg'
import digitalMarketingFeature from '../../Image/DigitalMarketing/Digital-Marketing-Feature.svg'
import { useParams } from 'react-router-dom';

const FeatureService = () => {
  const { category } = useParams();
  const featureHead = {
    web: {
      title: "Features of Website Development",
      des: "By keeping your budget in mind, our expert developers assist you in building an excellent website and maintaining it regularly."
    },
    mobile: {
      title: "Features of Mobile APP Development",
      des: "Mobile app development is a crucial software process in today’s world of digitalization and technology. Everyone uses mobile apps due to their user-friendliness and flexibility."
    },
    seo: {
      title: "Features of Search Engine Optimization",
      des: "Search Engine Optimization (SEO) is a multifaceted approach aimed at enhancing a website’s visibility in search engine results pages (SERPs). SEO encompasses various features and strategies that work together to achieve this goal."
    },
    fullStack: {
      title: "Features of Website Development",
      des: "By keeping your budget in mind, our expert developers assist you in building an excellent website and maintaining it regularly."
    },
    digitalMarketing: {
      title: "Features of Digital Marketing",
      des: "Digital marketing encompasses a range of features aimed at promoting products, services, or brands in the online landscape. It includes diverse strategies such as social media advertising, email campaigns, and pay-per-click advertising."
    },
    reactNative: {
      title: "Features of React Native",
      des: "By keeping your budget in mind, our expert developers assist you in building an excellent website and maintaining it regularly."
    }
  }
  const featureService = {
    web: {
      items: [
        { text: "Proper understanding of client's requirement", width: "2xl:w-full sm:w-fit w-full" },
        { text: "Friendly admin page for marketing purposes", width: "2xl:w-[90%] sm:w-fit w-full" },
        { text: "Required plugins for backend purpose", width: "2xl:w-[80%] sm:w-fit w-full" },
        { text: "Adequate structure of a website", width: "2xl:w-[65%] sm:w-fit w-full" },
        { text: "User – Friendly content", width: "2xl:w-[50%] sm:w-fit w-full" },
        { text: "A checkout page", width: "2xl:w-[35%] sm:w-fit w-full" },
        { text: "Security", width: "2xl:w-[20%] sm:w-fit w-full" }
      ],
      image: feature,
      alt: "Illustration"
    },
    mobile: {
      items: [
        { text: "Proper understanding of client's requirement", width: "2xl:w-full sm:w-fit w-full" },
        { text: "Friendly admin page for marketing purposes", width: "2xl:w-[90%] sm:w-fit w-full" },
        { text: "Required plugins for backend purpose", width: "2xl:w-[80%] sm:w-fit w-full" },
        { text: "Adequate structure of a website", width: "2xl:w-[65%] sm:w-fit w-full" },
        { text: "User – Friendly content", width: "2xl:w-[50%] sm:w-fit w-full" },
        { text: "A checkout page", width: "2xl:w-[35%] sm:w-fit w-full" },
        { text: "Security", width: "2xl:w-[20%] sm:w-fit w-full" }
      ],
      image: feature,
      alt: "Illustration"
    },
    seo: {
      items: [
        { text: "Content marketing and analysis", width: "2xl:w-full sm:w-fit w-full" },
        { text: "Keyword research/rank analysis", width: "2xl:w-[90%] sm:w-fit w-full" },
        { text: "Adequate structure of a website", width: "2xl:w-[80%] sm:w-fit w-full" },
        { text: "International search tracking", width: "2xl:w-[65%] sm:w-fit w-full" },
        { text: "Link analysis and acquisition", width: "2xl:w-[50%] sm:w-fit w-full" },
        { text: "Cross-device attribution", width: "2xl:w-[35%] sm:w-fit w-full" },
        { text: "Technical SEO crawling", width: "2xl:w-[20%] sm:w-fit w-full" }
      ],
      image: feature,
      alt: "Illustration"
    },
    fullStack: {
      items: [
        { text: "Proper understanding of client’s requirement", width: "2xl:w-full sm:w-fit w-full" },
        { text: "Friendly admin page for marketing purposes", width: "2xl:w-[90%] sm:w-fit w-full" },
        { text: "Required plugins for backend purpose", width: "2xl:w-[80%] sm:w-fit w-full" },
        { text: "Adequate structure of a website", width: "2xl:w-[65%] sm:w-fit w-full" },
        { text: "User – Friendly content", width: "2xl:w-[50%] sm:w-fit w-full" },
        { text: "A checkout page", width: "2xl:w-[35%] sm:w-fit w-full" },
        { text: "Security", width: "2xl:w-[20%] sm:w-fit w-full" }
      ],
      image: fullStackfeature,
      alt: "Illustration"
    },
    digitalMarketing: {
      items: [
        { text: "Advancement, High Performance, and Economical.", width: "2xl:w-full sm:w-fit w-full" },
        { text: "Unrestricted Space and Times and Rich Media.", width: "2xl:w-[90%] sm:w-fit w-full" },
        { text: "Identifying the Targeted Audience.", width: "2xl:w-[80%] sm:w-fit w-full" },
        { text: "Non-intrusive and Direct Method.", width: "2xl:w-[65%] sm:w-fit w-full" },
        { text: "Keep Expanding & Integrate.", width: "2xl:w-[50%] sm:w-fit w-full" },
        { text: "Interactive Communication.", width: "2xl:w-[35%] sm:w-fit w-full" },
        { text: "Technology-Supportive.", width: "2xl:w-[20%] sm:w-fit w-full" }
      ],
      image: digitalMarketingFeature,
      alt: "Illustration"
    },
    reactNative: {
      items: [
        { text: "Proper understanding of client's requirement", width: "2xl:w-full sm:w-fit w-full" },
        { text: "Friendly admin page for marketing purposes", width: "2xl:w-[90%] sm:w-fit w-full" },
        { text: "Required plugins for backend purpose", width: "2xl:w-[80%] sm:w-fit w-full" },
        { text: "Adequate structure of a website", width: "2xl:w-[65%] sm:w-fit w-full" },
        { text: "User – Friendly content", width: "2xl:w-[50%] sm:w-fit w-full" },
        { text: "A checkout page", width: "2xl:w-[35%] sm:w-fit w-full" },
        { text: "Security", width: "2xl:w-[20%] sm:w-fit w-full" }
      ],
      image: fullStackfeature,
      alt: "Illustration"
    }
  };

  return (
    <>
    <div className="container">
      <div className=' rounded-xl shadow-purple-md sm:px-8 px-3 py-8 my-14'>
        <div className='text-center mt-5'>
          <h2 class="text-2xl md:text-3xl font-bold text-gray-900 mb-2">{featureHead[category]?.title}</h2>
          <p class="text-sm text-gray-600 mb-6">{featureHead[category]?.des}</p>
        </div>
        <div class=" bg-white rounded-xl w-full flex flex-col lg:flex-row gap-10 pt-4">
          <div class="flex-1">
            <ul class="space-y-3 w-full md:ms-7">
              {featureService[category]?.items?.map((item, index) => (
                <li key={index} className={`bg-purple-100 text-[#555555] font-bold px-4 py-4 2xl:rounded-full rounded-[10px] text-md sm:text-lg shadow ${item.width}`}>{item.text}</li>
              ))}
            </ul>
          </div>
          <div class="flex-1 flex mx-auto"><img src={featureService[category]?.image} alt={featureService[category]?.alt} class="w-full max-w-xl"/></div>
        </div>
      </div>
    </div>
    </>
  )
}

export default FeatureService